<template>
  <div class="select-box">
    <template v-if="model == 'select'">
      <el-select v-model="newValue" :filterable="filterable" :placeholder="i18nConfig(placeholder)" style="width: 100%"
        :filter-method="filterMethod" :multiple="multiple" :disabled="disabled" :clearable="clearable" :name="name"
        @change="handleChange">
        <template v-for="item in options" :key="item[fieldNames.value]">
          <el-option :label="i18nConfig(item[fieldNames.label])" :value="item[fieldNames.value]"
            v-if="isCheckPermi(item)" />
        </template>
      </el-select>
    </template>
    <template v-else-if="model == 'showText'">
      {{ showText() }}
    </template>
    <template v-else-if="model == 'customClass'">
      <template v-for="(item, index) in options" :key="item[fieldNames.value]">
        <el-tag v-if="item[fieldNames.value] == value" :disable-transitions="true" :key="item[fieldNames.value] + ''"
          :index="index" :type="(item.elTagType === 'default' || item.elTagType == 'primary' || item.elTagType == '') ? 'primary' : item.elTagType"
          :class="item.cssClass">{{ i18nConfig(item[fieldNames.label]) }}
        </el-tag>
      </template>
      <el-tag v-if="value && !options.find(item => item[fieldNames.value] == value)" :disable-transitions="true">{{ value }}</el-tag>
    </template>
  </div>
</template>
  
<script>
import { checkPermi } from '@/utils/permission.js';
import { i18nConfig } from '@/utils/ruoyi'
import selectCustomFunction from './select-custom-function';
import useDictStore from '@/store/modules/dict';
import { getDicts } from '@/api/system/dict/data';
import { reactive, toRefs, onMounted, watch } from "vue";
export default {
  name: "gljy-select",
  emits: ["update:value", "update:label", "update:selectedOptions", "change", "resultQueryData"],
  props: {
    // 模式 select 是下拉框模式 showText 是文字显示模式
    model: {
      type: String,
      default: "select"
    },
    value: {
      type: [String, Number, Array, Boolean]
    },
    label: {
      type: [String, Number, Array, Boolean]
    },
    /**
     * presetFunction_*****
     * queryFunction:通过传入的查询函数,设置下拉框的下拉内容
     * dataSource: 自己指定数据源
     * 其他类型: 将类型通过数据字典工具向后台得到数据
     */
    type: {
      type: String,
      default: "queryFunction"
    },
    // 自己制定数据源
    dataSource: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 查询函数--type-queryFunction时,此函数必须配置
    queryFunction: {
      type: [Function, Promise],
      default: (proxy) => {
        // 如果是预设的function, 那么获取后续的拼接参数, 从js中得到预设function
        if (proxy.type?.indexOf("presetFunction") >= 0) {
          const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
          return selectCustomFunction[presetFunctionObjKey]?.queryFunction;
        }
        return () => {
        };
      }
    },
    // 查询条件--跟queryFunction配套使用
    extendQueryWhere: {
      type: Object,
      default: (proxy) => {
        if (proxy.type?.indexOf("presetFunction") >= 0) {
          const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
          return selectCustomFunction[presetFunctionObjKey]?.extendQueryWhere;
        }
        return {}
      }
    },
    // 是否自动触发 查询
    isAutoInit: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    // 是否缓存
    isCache: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    fieldNames: {
      type: Object,
      default: (proxy) => {
        if (proxy.type?.indexOf("presetFunction") >= 0) {
          const presetFunctionObjKey = proxy.type.substring("presetFunction".length + 1);
          return selectCustomFunction[presetFunctionObjKey]?.fieldNames;
        }
        return { value: 'dictValue', label: 'dictLabel' }
      }
    },
    // 禁用选择字段
    disabledValues: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    // 是否多选
    multiple: {
      type: Boolean,
    },
    // 支持清除
    clearable: {
      type: Boolean,
      default: true
    },
    // 是否有边框
    bordered: {
      type: Boolean,
      default: true
    },
    // 显示搜索框
    filterable: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    // 搜索时过滤对应的字段名
    name: {
      type: String,
      defaulet: (proxy) => {
        return proxy.fieldNames.label;
      }
    },
    filterMethod: Function,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const dicts = useDictStore();
    const datas = reactive({
      newValue: "",
      options: [],
      i18nConfig: i18nConfig
    })

    watch(() => props.dataSource, () => {
      if (props.type == "dataSource") {
        datas.options = props.dataSource;
      }
    }, { immediate: true })

    onMounted(() => {
      // 自动触发查询
      if (props.isAutoInit) {
        methods.init();
      }
    })

    const methods = {
      // 初始化
      async init(params) {
        if (props.type == null || props.type == "") return;
        const dict = dicts.dict;
        if (props.type.indexOf("presetFunction") >= 0 || props.type == "queryFunction" || props.type == "queryUrl") {
          let data = {};
          if (props.extendQueryWhere) {
            Object.keys(props.extendQueryWhere).forEach(key => {
              data[key] = props.extendQueryWhere[key]
            })
          }
          if (params) {
            Object.keys(params).forEach(key => {
              data[key] = params[key]
            })
          }
          let funName = methods.getFunctionName(props.queryFunction);
          if (props.type == "queryUrl") {
            funName = props.url;
          }
          let keyStr = `${funName}-${JSON.stringify(props.extendQueryWhere)}-${JSON.stringify(params)}`;
          if (dict && dict[keyStr] && props.isCache && dict[keyStr] != "notCache") {
            datas.options = dict[keyStr];
            methods.setCustomField(datas.options);
            methods.setValueDisabled();
            return;
          } else if (dict[keyStr] != null && dict[keyStr] == "notCache" && props.isCache) {
            setTimeout(() => {
              methods.init(params);
            }, 1000);
          } else {
            dicts.setDict(keyStr, "notCache");
            let res = null;
            if (props.type == "queryUrl") {
              res = await system.hsSelectQueryFunction(props.url, data);
            } else {
              if ((typeof props.queryFunction) == "object") {
                const functionAwait = await props.queryFunction;
                res = await functionAwait(data);
              } else {
                res = await props.queryFunction(data);
              }
            }
            // console.log("props.fieldNames", props.fieldNames)
            // console.log("props.queryFunction-keyStr", keyStr)
            // console.log("res", res)
            context.emit("resultQueryData", res);
            if (res.code == 200) {
              datas.options = res.rows ? res.rows : res.data;
              methods.setCustomField(datas.options);
              if (props.isCache) {
                dicts.setDict(keyStr, res.data);
              }
            } else {
              datas.options = [];
              if (props.isCache) dicts.setDict(keyStr, []);
            }
          }

        } else if (props.type == "dataSource") {
          datas.options = props.dataSource;
        } else {
          if (dict && dict[props.type] && props.isCache && dict[props.type] != "notCache") {
            datas.options = dict[props.type];
            methods.setCustomField(datas.options);
            methods.setValueDisabled();
            return;
          } else if (dict[props.type] != null && dict[props.type] == "notCache" && props.isCache) {
            setTimeout(() => {
              methods.init(params);
            }, 1000);
          } else {
            dicts.setDict(props.type, "notCache");
            const res = await getDicts(props.type);
            // console.log("res", res)
            context.emit("resultQueryData", res);
            if (res.code == 200) {
              datas.options = res.data;
              methods.setCustomField(datas.options);
              if (props.isCache) dicts.setDict(props.type, res.data);
            }
          }
        }
        methods.setValueDisabled();
      },
      isCheckPermi(item) {
        if (item.hasPermi != null && item.hasPermi != '') {
          return checkPermi([item.hasPermi])
        }
        return true;
      },
      // 设置禁用字段
      setValueDisabled() {
        const disabledValues = props.disabledValues;
        if (disabledValues != null && disabledValues.length > 0) {
          disabledValues.forEach(value => {
            const find = datas.options.find(f => f[props.fieldNames.value] == value);
            if (find) {
              find.disabled = true;
            }
          })
        }
      },
      // 设置自定义label值
      setCustomField(rows) {
        if (props.fieldNames.customField != null && typeof props.fieldNames.customField == "function") {
          rows.forEach(item => {
            props.fieldNames.customField(item);
          })
        }
      },
      // 设置数据字典默认值---有致命缺陷,暂时不使用
      setDictDefaultValue() {
        if (datas.newValue === undefined) {
          const defaultItem = datas.options.filter(item => item.defaultFlag == 1);
          if (defaultItem == null || defaultItem.length == 0) return;
          const value = defaultItem[0][props.fieldNames.value];
          const label = defaultItem[0][props.fieldNames.label];
          nextTick(() => {
            context.emit("update:value", value);
            context.emit("update:label", label);
            context.emit("update:selectedOptions", datas.options);
            context.emit("change", value, datas.options);
          })
        }
      },
      // showText模式显示 文字
      showText() {
        const fieldNames = props.fieldNames;
        const value = datas.newValue;
        if (value == null) return "";
        if (props.multiple) {
          let label = "";
          datas.options.forEach((option, index) => {
            if (value.includes(option[props.fieldNames.value])) {
              const labelStr = option[props.fieldNames.label];
              label = label + labelStr + ","
            }
          })
          return label.substring(0, label.length - 1);
        } else {
          const item = datas.options.find(item => item[fieldNames.value] == value);
          if (item != null) {
            return item[fieldNames.label]
          }
          return value;
        }
      },
      handleChange(value) {
        let label = undefined;
        let options = [];
        if (Array.isArray(value)) {
          value.forEach((v, index) => {
            const option = datas.options.find(item => item[props.fieldNames.value] === v);
            if (option) {
              const labelStr = option[props.fieldNames.label];
              if (props.multiple) {
                if (label == null) label = [];
                label.push(labelStr);
              } else {
                label = label + labelStr + (index < value.length - 1 ? "," : "")
              }
              options.push(option);
            }
          })
        } else {
          const option = datas.options.find(item => item[props.fieldNames.value] === value);
          if (option) {
            label = option[props.fieldNames.label];
            options.push(option);
          }
        }
        context.emit("update:value", value);
        context.emit("update:label", label);
        // console.log("datas.options", options, value, label)
        context.emit("update:selectedOptions", options);
        context.emit("change", value, options);
      },
      // 初始化时, 设置label数据
      handleInitSetLabel() {
        if (props.label != null && props.label != '' && props.value != null && props.value != '') return;
        // 多选
        let label = null;
        if (Array.isArray(props.value)) {
          props.value.forEach((valueItem, index) => {
            let find = datas.options?.find(item => item[props.fieldNames.value] == valueItem);
            if (find) {
              if (props.multiple) {
                if (label == null) label = [];
                label.push(find[props.fieldNames.label]);
              } else {
                label = label + find[props.fieldNames.label] + (index < props.value.length - 1 ? "," : "")
              }
            }
          })
        } else {
          const find = datas.options?.find(item => item[props.fieldNames.value] == props.value);
          if (find) label = find[props.fieldNames.label];
        }
        // console.log("label", label)
        context.emit("update:label", label);
      },
      getFunctionName(fun) {
        var ret = fun.toString();
        ret = ret.substr(0, ret.indexOf('('));
        return ret;
      }
    }

    watch(() => props.value, (newVal, oldVal) => {
      if (props.type != 'queryFunction' && props.type != 'dataSource' && !props.multiple) {
        datas.newValue = props.value + '';
      } else {
        datas.newValue = props.value;
      }
      if (props.value == null || props.value == "null" || props.value === undefined || props.value == "undefined") {
        if (props.multiple) {
          datas.newValue = [];
        } else {
          datas.newValue = undefined;
        }
      }
      // 设置label值
      methods.handleInitSetLabel();
    }, { immediate: true })

    watch(() => props.disabledValues, (disabledValues) => {
      methods.setValueDisabled();
    }, { immediate: true })

    return {
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>
  
<style lang="less">
.select-box {
  display: inline-block;
  width: 100%;
}
</style>